import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import 'react-toggle/style.css'
import '../../../styles/style.css'
import CustomButton from '../../Button/CustomButton'
import { useLocation } from 'react-router-dom'
import { PDFDownloadLink } from '@react-pdf/renderer'
import Pdf from '../../Download/Pdf'

function ModalDownloadQr(props) {
  const location = useLocation()
  const [showDownloadPdf, setShowDownloadPdf] = useState(false)
  const shardingItems = () => {
    const data = props?.slots?.reduce((acc, item) => {
      acc.push({
        id: item.id,
        name: item.code,
        qr: item.qr
      })
      return acc
    }, [])
    if (!data || data?.length === 0) return []
    const shardedData = []
    for (let i = 0; i < data?.length; i += 2) {
      shardedData.push(data.slice(i, i + 2))
    }
    return shardedData
  }
  return (
    <Modal {...props} centered>
      <Modal.Header closeButton>
        <Modal.Title>QR</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex w-100 justify-content-center">
          <img
            src={props.paletData.src}
            alt={props.paletData.paletName}
            className="img-fluid"
            width={'300'}
            height={'300'}
          />
        </div>
        <h5 className="fw-bold text-center">
          {props.type ?? 'Palet'} #{props.paletData.paletName}
        </h5>
      </Modal.Body>
      <Modal.Footer className="mt-3">
        <div className="d-flex w-100 gap-2 justify-content-center">
          {!location.pathname.includes('/setting/racks/detail') && (
            <CustomButton
              onClick={() =>
                downloadQr(props.paletData.src, props.paletData.paletName)
              }
              variant={'warning'}
              text={'Download QR'}
            />
          )}
          {location.pathname.includes('/setting/racks/detail') && (
            <>
              <PDFDownloadLink
                document={<Pdf data={shardingItems()} typeDownload={'beam'} />}
                fileName="print_qr_beam.pdf"
                onClick={() => {
                  setShowDownloadPdf(true)
                }}
              >
                {({ loading }) => {
                  if (!loading && showDownloadPdf) {
                    setTimeout(() => {
                      setShowDownloadPdf(false)
                      props.onHide()
                    }, 1000) // You can adjust the delay as needed
                  }

                  return (
                    <CustomButton
                      variant="warning"
                      text={
                        loading && !showDownloadPdf
                          ? 'Preparing...'
                          : 'Download Beam'
                      }
                      disabled={false}
                    />
                  )
                }}
              </PDFDownloadLink>
              <PDFDownloadLink
                document={<Pdf data={shardingItems()} typeDownload={'slot'} />}
                fileName="print_qr_slot.pdf"
                onClick={() => {
                  setShowDownloadPdf(true)
                }}
              >
                {({ loading }) => {
                  if (!loading && showDownloadPdf) {
                    setTimeout(() => {
                      setShowDownloadPdf(false)
                      props.onHide()
                    }, 1000) // You can adjust the delay as needed
                  }

                  return (
                    <CustomButton
                      variant="transparent"
                      classNameValue="btn-primary-blue"
                      text={
                        loading && !showDownloadPdf
                          ? 'Preparing...'
                          : 'Download Slot'
                      }
                      disabled={false}
                    />
                  )
                }}
              </PDFDownloadLink>
            </>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  )
}
const downloadQr = (imageSrc, imageName) => {
  const link = document.createElement('a')
  link.href = imageSrc
  link.download = imageName + '.png'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
export default ModalDownloadQr
